export enum SORTING_MODES {
    // arrow down
    NORMAL = 'normal',
    // arrow up
    REVERSE = 'reverse'
}

export const alphanumericalSort = (
    sortKey: string | null,
    sortMode = SORTING_MODES.NORMAL,
    options = {}
) => {
    return (a: any, b: any) => {
        const compareStringA = String(sortKey ? a[sortKey] : a);
        const compareStringB = String(sortKey ? b[sortKey] : b);

        return (sortMode === SORTING_MODES.NORMAL ? compareStringA : compareStringB).localeCompare(
            sortMode === SORTING_MODES.NORMAL ? compareStringB : compareStringA,
            undefined,
            {
                numeric: true,
                sensitivity: 'base',
                ...options
            }
        );
    };
};
